// © Microsoft Corporation. All rights reserved.

export enum Environment {
    prod = "prod",
    int1 = "int1",
    int = "int",
    intpr = "intPR",
    intpef = "intPef"
}

/**
 * Parses from string to Environment enum.
 * Defaults to null
 *
 * @export
 * @param {(string | null | undefined)} environment - string being parsed
 * @returns {(Environment | null)} - the parsed Environment enum, or null.
 */
export function getEnvironmentFromString(environment: string | null | undefined): Environment | null {
    switch (environment) {
        case Environment.prod:
            return Environment.prod;
        case Environment.int1:
            return Environment.int1;
        case Environment.int:
        case Environment.intpr:
        case Environment.intpef:
            return Environment.int;
        default:
            return null;
    }
}